import * as Yup from 'yup';

interface Props {
  senhaAtual: string;
  novaSenha: string;
  repetirSenha: string;
}

const validarErroForm = async (data: Props) => {
  const schema = Yup.object().shape({
    senhaAtual: Yup
      .string()
      .required('Senha atual é obrigatória'),
    novaSenha: Yup
      .string()
      .min(6, 'A senha deve conter no mínimo 6 caracteres')
      .required('Nova senha é obrigatória'),
    repetirSenha: Yup
      .string()
      .matches(new RegExp(`${data.novaSenha}$`), 'Senhas não correspondem')
      .required('Repetir nova senha é obrigatória'),
  });

  await schema.validate(data, {
    abortEarly: false,
  });
};

export default validarErroForm;
